var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logos",class:("logos--" + _vm.overlap),on:{"click":function($event){$event.preventDefault();_vm.$emit('click')}}},[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('logo')],1),_vm._v(" "),_c('a',{staticClass:"logo--fixed",attrs:{"href":"/"}},[_c('logo',{staticClass:"logo-big"}),_vm._v(" "),_c('logo-mini',{staticClass:"logo-mini"})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3beb9217","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderLogos.vue
// module id = null
// module chunks = 